module.exports = __webpack_public_path__ + "static/media/ico-close.3a3f1b95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico-close.svg
// module id = 256
// module chunks = 8